import { AssetArea, AssetCategory, Facility, Dict } from "../api/model"
import { AssetCategoryApi, AssetAreaApi, FacilityApi, AssetApi } from "../api/api"
import { UiUtils, JqElm } from "./ui"

export interface ValidationState {
    successIds: Array<string>
    failIds: Array<string>
}

export class AssetBasicDataProvider {
    catRoots: AssetCategory[]
    catParentMap: Map<number, Array<AssetCategory>>
    facilities: Array<Facility>
    areas: Array<AssetArea>
    areaMap: Dict<AssetArea>
    catMap: Dict<AssetCategory>

    constructor(
        private assetCategoryApi: AssetCategoryApi,
        private facilityApi: FacilityApi,
        private assetAreaApi: AssetAreaApi,
        private validateAreaExist: boolean = true
    ) {
    }

    async initCategories(): Promise<void> {
        const cats = (await this.assetCategoryApi.get()).data
        this.catMap = {}
        this.catParentMap = new Map<number, Array<AssetCategory>>()
        this.catParentMap.set(0, [])
        for (const cat of cats) {
            this.catMap[cat.id] = cat
            if (!this.catParentMap.has(cat.parentId)) {
                this.catParentMap.set(cat.parentId, [])
            }
            this.catParentMap.get(cat.parentId).push(cat)
        }
        this.catRoots = this.catParentMap.get(0)
    }

    async initFacilities(): Promise<void> {
        this.facilities = (await this.facilityApi.get()).data
    }

    async initAreas(): Promise<void> {
        let waitDocAlready = function () {
            return new Promise(function (resolve, reject) {
                var isAlready = false;
                var checkAlready = setInterval(function () {
                    isAlready = (document.readyState === "complete");
                    if (isAlready) {
                        clearInterval(checkAlready);
                        resolve(isAlready);
                    }
                }, 200);
            });
        }
        let docAlready = await waitDocAlready();

        this.areas = (await this.assetAreaApi.get()).data;
        if (this.validateAreaExist && this.areas.length == 0 && !location.href.endsWith('assetItem.aspx')) {
            //await ui_1.UiUtils.alert("尚為建立資產位置，請先至資產項目管理新增");
            //location.href = "assetItem.aspx";
            bootbox.alert("請先至【資產項目】管理新增資產位置，再下載匯入表單使用。", function () {
                location.href = "assetItem.aspx"
            });
        }
        this.areaMap = {}
        for (const area of this.areas) {
            this.areaMap[area.id] = area
        }
    }

    getAreaName(areaId?: number): string {
        const area = this.areaMap[areaId]
        return area != null ? area.name : '待分區'
    }

    getCategoryName(catId: number, spliter: string = '-'): string {
        const catNames = this.getCategoryNames(catId)
        return catNames != null ? catNames.join(spliter) : '待分類'
    }

    getCategoryNames(catId: number): [string, string] | null {
        const subCat = this.catMap[catId]
        if (subCat) {
            const cat = this.catMap[subCat.parentId]
            if (cat) {
                return [cat.name, subCat.isDefaultSubCat ? "其他" : subCat.name]
            }
        }
        return null
    }
}

export abstract class AssetPageBase {

    protected statusNameMap: Dict<string> = {
        'loan': '借出',
        'inStock': '在庫',
        'malfunction': '故障',
        'repair': '維修',
        'scrap': '報廢'
    }

    constructor(
        protected assetApi: AssetApi,
        protected assetBasicDataProvider?: AssetBasicDataProvider
    ) {
    }

    getCommName(): string {
        return $('#m_com').text()
    }

    async initCategories(): Promise<void> {
        await this.assetBasicDataProvider.initCategories()
    }

    async initFacilities(): Promise<void> {
        await this.assetBasicDataProvider.initFacilities()
    }

    async initAreas(): Promise<void> {
        await this.assetBasicDataProvider.initAreas()
    }

    protected elmById(id: any, className?: string, name?: string, optSelector?: string): JqElm {
        return UiUtils.elmById.apply(UiUtils, arguments)
    }

}